var styles = {"tend-ui-form-label-root":"tend-ui-form-label-root"};

export { styles as default };
